// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KgTXN","newExpiryDate":"styles_newExpiryDate__2j_b7","footer":"styles_footer__1p-Js"};